import { IconProps } from 'interfaces';
import COLOR from 'constants/color';

const PlayCircle = ({
  fill = COLOR.GRAY['900'],
  className = 'w-4 h-4',
  styles
}: IconProps) => {
  return (
    <svg
      className={styles || className}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      preserveAspectRatio='xMidYMid meet'
    >
      <circle
        cx='12'
        cy='12'
        r='10'
        stroke={fill}
        strokeWidth='2'
        fill='none'
      />
      <path d='M10 8l6 4-6 4V8z' fill={fill} />
    </svg>
  );
};

export default PlayCircle;
